<template>
  <div>
    <div class="navigation-title"><span @click="()=>{$router.push('/news')}">{{ $t('News') }} </span><i class="el-icon-arrow-right"></i> {{ article.title }}</div>
    <div class="news-article">
      <h2 style="text-align: center;">{{ article.title }}</h2>
      <div class="meta">
        <span style="position: relative;top: 0rem;">
          <span class="date"> <i class="el-icon-time"></i> {{ article.createDate }}</span>
          <span class="views"><i class="el-icon-view"></i> {{ article.pageView }}</span>
        </span>
        <span>
          {{$t('Share')}}：
          <span style="position: relative;top: -0.1rem;">
            <!-- <img src="@/assets/img/weixin.png" alt="" style="width: 1.3rem;height: 1.3rem;margin-left: 0.5rem;cursor: pointer;"> -->
            <img src="@/assets/img/weibo.png" alt="" style="width: 1.3rem;height: 1.3rem;margin-left: 0rem;cursor: pointer;" @click="toWeibo">
          </span>
        </span>
      </div>
      <div class="content" v-if="isMobile=='pc'">
        <div v-html="article.content" class="details-content"></div>
      </div>
      
      <div class="content-mobile" v-if="isMobile=='mobile'">
        <div v-html="article.content" class="news-article-content"></div>
      </div>
      
      <el-divider></el-divider>
      <div class="news-article-bottom">
        <span @click="upPage?toNewsDetail(upPage?upPage.id:0,fundId):''" style="cursor: pointer;width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
          <span style="color: #8A8A8A;">{{$t('PreviousArticle')}}：{{upPage?upPage.title:$t('noArticle') }} </span>
        </span>
        <span @click="downPage?toNewsDetail(downPage?downPage.id:0,fundId):''" style="cursor: pointer;width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
          <span style="color: #8A8A8A;cursor: pointer;">{{$t('NextArticle')}}：{{downPage ?downPage.title:$t('noArticle')}}</span>
        </span>
      </div>
    </div>
  </div>

</template>

<script>
import { getArticleById,getUpPage } from '@/api/index';
export default {
  props: {
    // article: {
    //   type: Object,
    //   required: true
    // }
  },
  data() {
    return {
		upPage:{},
		downPage:{},
      article: {
        // id:'1',
        // title: '杭州足球学院落户杭师大 | 杭州足球学院与萨马兰奇体育发展基金会签订战略合作协议',
        // date: '2024-11-14',
        // views: 1033,
        // image: 'path/to/image.jpg', // 替换为实际图片路径
        // content: `
        //   <p>11月13日，杭州足球学院建设推进会在杭师大召开。杭师大校党委书记郭东风出席会议并讲话，全面落实杭州市全国足球发展重点城市建设工作动员部署会精神和省委副书记、市委书记刘捷关于杭州足球学院建设发展系列重要讲话要求，进一步统一思想、凝聚合力，以更高标准、更严要求、更实举措把足球学院建设抓深抓实抓到位，全力以赴建成在业界具有较大影响力的高水平足球学院，为杭州开创足球事业改革发展新局面、书写全国足球发展重点城市建设新篇章作出师大应有贡献。</p>
        //   <p>国际奥委会执委、中国奥委会副主席、萨马兰奇体育发展基金会理事长、正校级领导李玲蔚，浙江省教育厅体卫艺处处长唐玲丽、杭州市委编办副主任张星星，市体育局党组成员、副局长吴璐琪，杭州市教育局、萨马兰奇体育发展基金会相关人员，以及杭师大校党委委员胡绍华出席会议。党委委员、副校长黄兆信主持会议。与会人员共同见证杭州足球学院挂牌。</p>
        //   <p>作为杭州足球改革的一项重要探索,市委、市政府高度重视杭州足球学院的规划和建设工作,决定依托杭州师范大学建设杭州足球学院。在杭州市全国足球发展重点城市建设工作动员部署会上，省委副书记、市委书记刘捷亲自为学院揭牌，对学院建设发展提出明确要求和殷切期望。近期，杭师大校党委书记郭东风带队专程赴成都有关高校调研，学习足球学院建设方面的有益经验。</p>
        // `
      }
    }
  },
  computed:{
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  mounted() {
    const meta = document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'never');
    document.head.appendChild(meta);

    this.id = this.$route.query.id
	this.fundId = this.$route.query.fundId
    this.getArticleByIds(this.id,this.fundId)
	this.getUpPage(this.id,this.fundId)
  },
  methods: {
    toNewsDetail(id,fundId) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: id,
		  fundId: fundId
        }
      })
    },
    toWeibo() {
      // console.log("this.$utils",this.$utils);
	  if(this.article.url == null || this.article.url == ''){
		  this.shareToSinaWeiBo(this.article.title, window.location.href, this.article.imgUrl)
	  }else{
		  this.shareToSinaWeiBo(this.article.title, this.article.url, this.article.imgUrl)
	  }
    },

     getArticleByIds(id,fundId) {
      let form = new FormData();
      form.append("id", id);
	  form.append("moduleTypeId", fundId);
	  getArticleById(form).then(res => {
			if (res.data && res.data != null) {
			  this.article = res.data
			}
		})
    },
	
	 getUpPage(id,fundId) {
	  let form = new FormData();
	  form.append("id", id);
	  form.append("moduleTypeId", fundId);
	  getUpPage(form).then(res => {
	  			if (res.data && res.data != null) {
	  			  this.downPage = res.data.downPage;
				  this.upPage = res.data.upPage;
	  			}
	  		})
	}
	
  }
};
</script>

<style lang="less" scoped>
.news-article {
  box-sizing: border-box;
  background-color: white;
  padding: 2rem;
  padding-top: 1rem;
  width: 80%;
  margin: 2rem auto;
  border-radius: 0.3rem;
  position: relative;
  .news-article-bottom {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

.meta {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  color: #888;
  .views {
    margin-left: 2rem;
  }
}

.content {
  font-size: 1rem;
  line-height: 2rem;
  .details-content {
    display: inline-block;
    // overflow: auto;
    width: 100%;
    img {
      width: 100% !important;
    }
  }
}

.content-mobile{
  .news-article-content{
    display: inline-block;
    width: 100%;
    img{
      width: 100% !important;
      height: 20rem !important;
    }
  }
}



.news-image {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

</style>
